import { serviceRoles } from "config/access";
import { SEARCH } from "constants/routes";
import { checkAccess } from "helpers/auth";
import SearchPage from "./container/SearchPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin, account.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SEARCH,
    withSidebar: true,
    withAppBar: true,
    component: SearchPage,
  };
}
